import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { getResetByTag, rem, colors, zIndex } from '../../../styles';
var autoCompleteDropdownStyles = function autoCompleteDropdownStyles() {
  return /*#__PURE__*/css("background-color:", colors.white, ";border-bottom:none;border-top:none;box-shadow:", rem(0, 4, 8), " rgba(0, 0, 0, 0.15);box-sizing:border-box;color:", colors.coolGray_900, ";margin:", rem(0, -4), ";position:absolute;top:100%;width:calc(100% + 0.5rem);z-index:", zIndex.zIndex_9, ";>div:first-of-type{max-height:", rem(272), ";overflow-y:auto;width:100%;}" + (process.env.NODE_ENV === "production" ? "" : ";label:autoCompleteDropdownStyles;"));
};
var resetStyles = getResetByTag('div');
var StyledAutoCompleteDropdown = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1ed7ivm0"
} : {
  target: "e1ed7ivm0",
  label: "StyledAutoCompleteDropdown"
})(resetStyles, autoCompleteDropdownStyles);
export default StyledAutoCompleteDropdown;